/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const ChromeDownloadIcon: any = (props: {}) => {
  return (
    <svg width="3" height="15" viewBox="0 0 3 15" fill="none">
      <circle cx="1.5" cy="1.5" r="1.5" fill="#111213" />
      <circle cx="1.5" cy="13.5" r="1.5" fill="#111213" />
      <circle cx="1.5" cy="7.5" r="1.5" fill="#111213" />
    </svg>
  );
};

export default ChromeDownloadIcon;
